import type GlobalModel from 'echarts/types/src/model/Global';

export function install(registers) {
  registers.registerAction(
    { type: 'dvPetalShowHidden', update: 'none' },
    (payload, ecModel: GlobalModel, api) => {
      const result = ecModel.findComponents({
        mainType: 'series',
        subType: 'custom'
      });
      result.forEach(seriesModel => {
        const ele = api.getViewOfSeriesModel(seriesModel).group.childOfName(payload.dataIndex);
        if (payload.state === false || ele?.shape.dvState === false) {
          ele?.attr({
            ignore: false
          });
        } else {
          ele?.attr({
            ignore: true
          });
        }
      });
    }
  );
}
